import { THEME_MODE_TOKEN } from "constants/common";
import { ThemeMode } from "enums/theme";
import { PropsWithChildren, createContext, useState } from "react";

interface State {
  mode: ThemeMode;
  toggleMode: () => void;
}

const themeMode = localStorage.getItem(THEME_MODE_TOKEN);

const DEFAULT_STATE = {
  mode: themeMode || ThemeMode.LIGHT,
  toggleMode: () => {},
} as State;

export const AppContext = createContext(DEFAULT_STATE);

export const AppProvider = (props: PropsWithChildren) => {
  const [mode, setMode] = useState<ThemeMode>(DEFAULT_STATE.mode);

  const toggleMode = () => {
    const mappedMode = {
      [ThemeMode.LIGHT]: ThemeMode.DARK,
      [ThemeMode.DARK]: ThemeMode.LIGHT,
    }[mode];

    localStorage.setItem(THEME_MODE_TOKEN, mappedMode);

    setMode(mappedMode);
  };

  const value = {
    mode,
    toggleMode,
  } as State;

  return (
    <AppContext.Provider value={value}>{props.children}</AppContext.Provider>
  );
};
